import IntegrationsTab from "./Integrations/IntegrationsTab";
import {
  INTEGRATION_ROUTE,
  INSTAGRAM_CONTACTS,
  INSTAGRAM_CREDITS,
  INSTAGRAM,
} from "./OnboardingPage/routeNames";
import InstagramIntegration from "./Integrations/Instagram/InstagramIntegration";
import InstagramContactsList from "./Integrations/Instagram/InstagramContactsList";
import InstaAutomationPricing from "./Integrations/Instagram/InstaAutomationPricing";
import InstagramWrapper from "./Integrations/Instagram/InstagramWrapper";
import ProfileSettings from "./Profile/ProfileSettings";

export const protected_routes = [
  {
    path: INTEGRATION_ROUTE,
    component: <IntegrationsTab />,
  },
  {
    path: "/integrations/instagram",
    component: <InstagramIntegration />,
  },
  {
    path: INSTAGRAM,
    component: <InstagramWrapper />,
  },
  {
    path: "/settings",
    component: <ProfileSettings />,
  },
];

export const getInstagramRoutes = () => {
  return [
    {
      name: "Contacts",
      path: INSTAGRAM_CONTACTS,
      component: <InstagramContactsList />,
    },
    {
      name: "Credits",
      path: INSTAGRAM_CREDITS,
      component: <InstaAutomationPricing />,
    },
  ];
};
